import { ComponentProps, forwardRef } from 'react'

import { FaqSettingMinimal, InformationLayout } from '@karakuri-web/faq-type'

import { QAContent, QAHeader, QAPanel } from '../components'
import { useFaqRouting } from '../contexts/FaqRoutingContext'
import { values } from '../utils'

/**
 * お知らせウィジェット用の設定インターフェース
 */
export interface InformationWidgetSettings extends FaqSettingMinimal {
  informations?: ReadonlyArray<{ id?: string | null; title?: string | null }> | null
}

interface Props<T extends InformationWidgetSettings = InformationWidgetSettings> {
  data: { settingYaml: T }
  layout: InformationLayout
}

/**
 * お知らせウィジェット
 * お知らせFAQを表示する
 */
export function InformationWidget<T extends InformationWidgetSettings = InformationWidgetSettings>({
  layout,
  data,
}: Props<T>) {
  const { Link } = useFaqRouting()
  const informations = values(data.settingYaml.informations, [])
  if (!informations || informations.length === 0) {
    return null
  }
  return (
    <QAPanel className="faq-panel-information" data-testid="faq-panel-information">
      <QAHeader title={`${layout.title || 'お知らせ'}`} />
      {informations.map(({ id, title }) => {
        if (!id || !title) {
          return null
        }
        const LinkComponent = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>(
          function LinkComponent(props, ref) {
            return <Link ref={ref} {...props} to={`/answer/${id}/`} />
          }
        )
        return <QAContent key={id} question={title} LinkComponent={LinkComponent} info />
      })}
    </QAPanel>
  )
}
